import {QUESTIONSET_STATUS, QUESTIONSET_STATUSES} from 'client/constants';

export const authoringQuestionSetExtensions = {
  getQuestions() {
    return this.cache('getQuestions', () => {
      return this.getAuthoringQuestions();
    });
  },
  hasMultipleQuestions() {
    return this.getMeta().getCountOfQuestions() > 1;
  },
  isFree() {
    // We'll want to add the option for these to be free in the future
    return false;
  },

  // @todo: Clean this up once status codes go away in dev.
  isRejected() {
    return this.getStatusCode
      ? this.getStatusCode() === QUESTIONSET_STATUS.REJECTED
      : this.getStatus() === QUESTIONSET_STATUSES.REJECTED;
  },
  isDraft() {
    return this.getStatusCode
      ? this.getStatusCode() === QUESTIONSET_STATUS.DRAFT_MODE
      : this.getStatus() === QUESTIONSET_STATUSES.DRAFT_MODE;
  },
  isInReview() {
    return this.getStatusCode
      ? this.getStatusCode() === QUESTIONSET_STATUS.IN_REVIEW
      : this.getStatus() === QUESTIONSET_STATUSES.IN_REVIEW;
  },
  isPublished() {
    return this.getStatusCode
      ? this.getStatusCode() === QUESTIONSET_STATUS.PUBLISHED
      : this.getStatus() === QUESTIONSET_STATUSES.PUBLISHED;
  }
};
